import {createAction} from 'redux-actions';
import {push, replace} from "connected-react-router";
import {batchActions} from "redux-batched-actions";
import {
    createLlamaStateSelector,
    createStickerIdSelector,
} from '../create-llama/selectors';
import cacheManager from '../../domain/services/StickerCache';
import fileUploader from "../../../upload/FileUploader";
import stickerItemsRepositoryBuilder from '../../domain/factories/StickerItemsRepositoryBuilder';
import {getCookie} from '../../../../infrastructure/helpers';
import * as Noty from 'noty';

import {setProcessingLoaderVisibility, setGeneratingLoaderProgress} from "../../../layout/store/actions";
import mediaManager from "../../domain/services/MediaManager";
import {mediaVideoStateSelector} from "./selectors";
import {setPreparedMedia} from '../create-llama/actions';
import authService from "../../../auth/domain/services/AuthService";
import {isCurrentUserLoggedSelector, currentUserSelector} from '../../../auth/store/auth-user/selectors';

const namespace = 'MEDIA_VIDEO';

export const recordVideo = createAction(`${namespace}/RECORD_VIDEO`);
export const resetState = createAction(`${namespace}/RESET_STATE`);
export const restoreVideo = createAction(`${namespace}/RESTORE_STATE`);
export const stopPlaying = createAction(`${namespace}/STOP_PLAYING`);
export const startPlaying = createAction(`${namespace}/START_PLAYING`);

export const convertVideoRequest = createAction(`${namespace}/CONVERT_VIDEO_REQUEST`);
export const convertVideoSuccess = createAction(`${namespace}/CONVERT_VIDEO_SUCCESS`);
export const convertVideoFailed = createAction(`${namespace}/CONVERT_VIDEO_FAILED`);

export const setOriginVideo = createAction(`${namespace}/SET_ORIGIN_VIDEO`);
export const setOriginVideoInfo = createAction(`${namespace}/SET_ORIGIN_VIDEO_INFO`);
export const setResultVideo = createAction(`${namespace}/SET_RESULT_VIDEO`);
export const setLayoutSize = createAction(`${namespace}/SET_LAYOUT_SIZE`);

export const mediaStreamFailed = createAction(`${namespace}/MEDIA_STREAM_FAILED`);

export function onVideoSelected(file) {
    return (dispatch, getState) => {
        const urlCreator = window.URL || (window as any).webkitURL;
        const videoUrl = urlCreator.createObjectURL(file);
        dispatch(setProcessingLoaderVisibility(true));
        dispatch(batchActions([
            setProcessingLoaderVisibility(false),
            setOriginVideo({uri: videoUrl, blob: file}),
        ]));

        if (file.type === 'video/webm') {
            // const formData = new FormData();
            // formData.append('video', file);
            // uqVideoUploadResource.create(formData, {
            //   contentType: 'multipart/form-data'
            // })
            // .then((res) => { console.log('res', res) })
            // .catch((error) => { console.log('error', error) });
        }
    };
}

export function videoDone(playerRef) {
    return (dispatch, getState) => {

        dispatch(setProcessingLoaderVisibility(true));
        const videoState = mediaVideoStateSelector(getState());

        const stickerState = createLlamaStateSelector(getState());
        const stickerId = createStickerIdSelector(getState());

        stickerState.form['is_need_convert_video'] = videoState.resultVideoBlob.type === 'video/webm';
        const videoUploadingPromise = () => {
            uploadVideo(dispatch, getState)
                .then((uploadedVideo) => {
                    dispatch(setPreparedMedia(uploadedVideo));
                    cacheManager.cacheUploadedMedia(stickerState, uploadedVideo);
                })
                .then(() => {
                    fileUploader.onUploadComplete && fileUploader.onUploadComplete()
                })
                .catch((error) => {
                    new Noty({
                        type: 'warning',
                        timeout: 4000,
                        text: JSON.stringify(error),
                    }).show();
                })
        };
        playerRef.play();
        mediaManager.createThumbnailFromVideo(playerRef)
            .then(({blob, path, duration}) => {
                dispatch(batchActions([
                    setResultVideo({
                        uri: videoState.resultVideoPath,
                        previewUri: path,
                        previewBlob: blob,
                    }),
                    setOriginVideoInfo({duration}),
                    setProcessingLoaderVisibility(false),
                    push(`/stickers/${stickerId}/new/preview`)
                ]));
                cacheManager.cacheMediaAsBlob(stickerState, mediaVideoStateSelector(getState()));
            })
            .then(() => {
                if (isCurrentUserLoggedSelector(getState())) {
                    videoUploadingPromise();
                } else {
                    authService.signInAnonymously()
                        .then(() => {
                            fileUploader.isUploading = true;
                            videoUploadingPromise();
                        })
                }
            }).catch((err) => {
            new Noty({
                type: 'warning',
                timeout: 4000,
                text: JSON.stringify(err),
            }).show();
            dispatch(setProcessingLoaderVisibility(false));
        });
    };
}

export function uploadVideo(dispatch, getState) {
    const {resultVideoBlob, resultPreviewBlob, duration} = mediaVideoStateSelector(getState());
    const stickerState = createLlamaStateSelector(getState());

    const folderName = stickerState.scannedSticker.id;

    const accessToken = getCookie('accessToken');

    return stickerItemsRepositoryBuilder.buildWithStickerItem(stickerState)
        .canCurrentUserWriteInStickerItem(stickerState.scannedSticker, accessToken)
        .then(() =>
            currentUserSelector(getState()).getIdToken(true)
                .then((token) => {
                    authService.setAuthTokenInHeaders(token)
                })
                .then(() => {
                        return Promise.all([
                            fileUploader.upload(resultVideoBlob, {folderName}, (progress) => {
                                dispatch(setGeneratingLoaderProgress(progress));
                            }),
                            fileUploader.upload(resultPreviewBlob, {folderName})
                        ])
                            .then(([videoResult, thumbnailResult]) => {
                                dispatch(setGeneratingLoaderProgress(null));
                                return {
                                    duration: duration,
                                    thumbnail: thumbnailResult,
                                    original: videoResult
                                };
                            })
                    }
                )
        )
        .catch(() => {
            new Noty({
                type: 'error',
                timeout: 3000,
                text: `Sticker access error`,
            }).show();
        });
}

export function fallbackMediaStreamRecord() {
    return (dispatch, getState) => {
        new Noty({
            type: 'info',
            timeout: 4000,
            text: `Ooop. Try again please. This will not happen again`,
        }).show();
        dispatch(batchActions([
            mediaStreamFailed(),
            replace('/new/format')
        ]));
    };
}

export function resetMediaFromStream() {
    return (dispatch, getState) => {

        // new Noty({
        //   type: 'info',
        //   timeout: 4000,
        //   text: `Ooop. Try again please. This will not happen again`,
        // }).sticker-item-show();
        // dispatch(batchActions([
        //   mediaStreamFailed(),
        //   replace('/new/format')
        // ]));
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/media-video/actions.ts